'use client';

import { Toaster } from '@appgnostic/design-system';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from 'next-auth/react';
import { useState } from 'react';

import { AccountReviewDialogProvider } from '@/src/features/integrations/components/dialogs';
import { PlatformErrorProvider } from '@/src/features/integrations/context';

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <PlatformErrorProvider>
          <AccountReviewDialogProvider>
            {children}
            <Toaster position="top-right" />
          </AccountReviewDialogProvider>
        </PlatformErrorProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
}
